import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleCustomer } from "./Constant/Source";
import CustomerCreateForm from "./Forms/CustomerCreateForm";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const CustomerCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleCustomer.create}>
      <SimpleForm>
        <CustomerCreateForm />
      </SimpleForm>
    </Create>
  );
};

export default CustomerCreate;
